import { Pipe, PipeTransform } from '@angular/core';
import { OperationType } from '@app/core/models/activities-log/activity-log.model';

@Pipe({
  name: 'activityOperation'
})
export class ActivityOperation implements PipeTransform {

  transform(value: any): string {

    if (value == OperationType.Added) {
      return 'Ajout';
    }

    if (value == OperationType.Modified) {
      return 'Modification';
    }

    if (value == OperationType.Deleted) {
      return 'Suppression';
    }
  }
}